// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomerSupportModal_root__P9SSL","title":"CustomerSupportModal_title__12X1t"};